import React, { useEffect, useState } from "react";
import Header from "../../../components/header";
import "./career-development-page.css";

//Images
import Home_Background from "../../../assets/career_development_background.jpg";

import { ParallaxProvider } from "react-scroll-parallax";
import NumberCard from "./numbercard";
import ScrollTrigger from "react-scroll-trigger";
import FlipCard from "./FlipCard";

//Charts
import CareerDevelopmentCharts from "./CareerDevelopmentCharts";
import CareerDevelopmentCharts02 from "./CareerDevelopmentCharts02";

import SpotLight from "./spotlight/SpotLight";

//AOS
import Aos from "aos";
import "aos/dist/aos.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";

export default function Homepage() {

  const handleScrollToNext = () => {
    const nextSection = document.getElementById("career");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [renderState, setRenderState] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <ParallaxProvider>
      <div className="screen-page">
        <Header />
        {/* section 01 */}
        <div style={{ position: "relative" }}>
          <div className="home-page-video">
            <div>
              <img
                src={Home_Background}
                style={{ height: "100vh", width: "100%", objectFit: "cover" }}
                alt=""
              />
            </div>
          </div>

          {/* <div style={{ marginLeft: "20px" }}>
            <div className="career-text-box">
              <div>
                <Parallax speed={10}>
                  <h1 className="career-topic-home">
                    CAREER
                    <br />
                    DEVELOPMENT
                  </h1>
                </Parallax>
              </div>
            </div>
          </div> */}

          {/* White Box */}
          <div className="white-box">
            <div className="white-box-container">
              {/* <h1>
                Modern <span className="white-box-container-h1">& Unique</span>
              </h1> */}
              <div className="screen-pc">
                <h1 className="white-box-container-h1-text" style={{ fontSize: "55px" }}>
                  {/* Conserve <br /> */}
                  <span className="white-box-container-h1">Career<br />Development</span>
                </h1>
              </div>

              <div className="screen-mobile">
                <p className="white-box-container-h1-text">
                {/* Conserve <br /> */}
                  <span className="white-box-container-h1">
                  Career<br />Development
                  </span>
                </p>
              </div>

              {/* Button to scroll to the next section */}
              <div onClick={handleScrollToNext} className="scroll-button">
                <FontAwesomeIcon icon={faArrowDown} style={{ fontSize: "16px" }} />
              </div>
            </div>
          </div>

          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "calc(100vh - 120px)",
              backgroundColor: "rgba(0, 0, 0, 0.15)",
              zIndex: 0,
            }}
          ></div>

          {/* H Letter Design */}
          <div className="h-banner-container">
            {/* Left Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-left"></div>
            </div>

            {/* Middle Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-design-N">
                <div className="h-left-N"></div>
                <div style={{ height: "350px" }} />
                <div className="h-right-N"></div>
              </div>
            </div>

            {/* Right Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-right"></div>
            </div>
          </div>

        </div>

        {/* section-2 */}
        <div className="career-cards">
          <div className="career-para-box">
            <div data-aos="zoom-in">
              <h1 className="career-para-two" id="career">CAREER</h1>
            </div>
            <div data-aos="fade-left">
              <center>
                <div className="career-card-width">
                  <NumberCard />
                </div>
              </center>
            </div>
          </div>
        </div>

        {/* section-3 */}
        <div className="euqality-paragraph-section-1">
          <ScrollTrigger onEnter={() => setRenderState(true)}>
            {renderState && (
              <center className="euqality-paragraph-section-1-center">
                <p>
                  The development of our people is a vital focus area of the
                  Hirdaramani culture. We offer a range of career development
                  and enhancement programs aimed at achieving two goals:
                </p>
                <ul className="career-paragraph-section-1-center-yello-p">
                  <li>80% of supervisors to be reached through career advancement programs by 2025.</li>
                  <li>60% of executives to be reached through career advancement programs by 2025.</li>
                </ul>
              </center>
            )}
          </ScrollTrigger>
        </div>

        {/* Section 4 */}
        <CareerDevelopmentCharts />

        {/* Section 5 */}
        <SpotLight />

        {/* Section 6 */}
        <CareerDevelopmentCharts02 />

        {/* Section - 7 */}
        <FlipCard />
      </div>
    </ParallaxProvider>
  );
}
